<template>
  <b-container class="edit-specialty">
    <b-form @submit.prevent="onSubmit">
      <div class="float-right">
        <b-button variant="default" @click="cancel()">
          Cancel
        </b-button>
        <b-button type="submit" variant="info">
          Save
        </b-button>
      </div>
      <h2 class="mb-3">{{ pageTitle }}</h2>
      <b-form-group
        horizontal
        label-cols="3"
        :invalid-feedback="codeInvalidFeedback"
        label="Code:"
      >
        <b-form-input
          type="text"
          v-model="$v.code.$model"
          :state="validateState('code')"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group
        horizontal
        label-cols="3"
        :invalid-feedback="titleInvalidFeedback"
        label="Title:"
      >
        <b-form-input
          type="text"
          v-model="$v.title.$model"
          :state="validateState('title')"
        >
        </b-form-input>
      </b-form-group>
      <b-form-group
        horizontal
        label-cols="3"
        :invalid-feedback="masterCodeInvalidFeedback"
        label="Master Code:"
      >
        <b-form-select
          v-model="$v.master_code.$model"
          :options="masterCodeOptions"
          :state="validateState('master_code')"
        />
      </b-form-group>
    </b-form>
  </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'specialtyForm',
  mixins: [validationMixin],
  props: {
    initialData: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
  },
  data() {
    return {
      code: this.initialData ? this.initialData.code : null,
      title: this.initialData ? this.initialData.title : null,
      master_code: this.initialData ? this.initialData.master_code : null,
    };
  },
  validations: {
    code: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(8),
    },
    title: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(128),
    },
    master_code: {
      minLength: minLength(2),
      maxLength: maxLength(8),
    },
  },
  computed: {
    specialtyOptions: function () {
      return this.$store.state.specialtyOptions;
    },
    masterCodeOptions: function () {
      return this.$store.getters.masterSpecialtyOptions.map(
        ({ specialty }) => ({
          value: specialty.code,
          text: specialty.code,
        })
      );
    },
    codeInvalidFeedback: function () {
      if (!this.$v.code.maxLength) {
        return "Code can't be more than 8 characters.";
      }
      if (!this.$v.code.minLength) {
        return "Code can't be less than 2 characters.";
      }
      return 'This field is required';
    },
    masterCodeInvalidFeedback: function () {
      if (!this.$v.master_code.maxLength) {
        return "Code can't be more than 8 characters.";
      }
      return "Code can't be less than 2 characters.";
    },
    titleInvalidFeedback: function () {
      if (!this.$v.title.maxLength) {
        return "Title can't be more than 128 characters.";
      }
      if (!this.$v.title.minLength) {
        return "Title can't be less than 2 characters.";
      }
      return 'This field is required';
    },
    pageTitle: function () {
      return this.initialData ? 'Edit Specialty' : 'Create new Specialty';
    },
  },
  methods: {
    cancel: function () {
      this.$emit('formCancel');
    },
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSubmit: function () {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.$emit('formSubmit', {
        ...(this.initialData || {}),
        code: this.code,
        title: this.title,
        master_code: this.master_code,
        is_master: 0,
      });
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss"></style>
